import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  height: 750px;
  width: 100%;
`;

export const List = styled.ul`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  > div {
    & + div {
      margin-left: 30px; // BigButton margin between items
    }
  }
`;
